import { handleActions } from 'redux-actions'
import types from '../actions/types'

export const defaultState = {}

export default handleActions({
	[types.RESULTS_UPDATED]: (state, { payload }) => {
		if (payload.results) {
			return {
				...state,
				[payload.pollId]: payload.results,
			}
		}
		const newState = { ...state }
		delete newState[payload.pollId]
		return newState
	},
}, defaultState)



// WEBPACK FOOTER //
// ./src/redux/reducers/results.js